import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { WorkerCreateContent } from './WorkerCreateContent';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

export class WorkerCreateScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
            Breadcrumbs.MY_CONTRACTORS_WORKERS,
            Breadcrumbs.MY_CONTRACTORS_WORKERS_ADD,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_NUEVO_TRABAJADOR_PARA_MIS_CONTRATISTAS')} breadcrumbs={breadcrumbs}>
                <WorkerCreateContent/>
            </PsPage>
        );
    }
}

WorkerCreateScreen.propTypes = {};

WorkerCreateScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/create/WorkerCreateScreen.jsx